<template>
  <v-container>
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="10"
        lg="8"
        xl="6"
      >
        <v-card>
          <v-container>
            <div>
              <v-card-text
                class="font-weight-bold title text-center"
              >서비스 이용 정보</v-card-text>
              <v-btn
                small
                color="error"
                style="position:absolute;margin-left:auto;right:0;top:25px;margin-right:5px"
                to="/payment"
              >요금 안내</v-btn>
            </div>

            <v-divider></v-divider>
            <v-card-text
              align="center"
              v-if="paymentHistory && paymentHistory.length === 0"
              >서비스 이용 정보가 없습니다.
            </v-card-text>

            <v-simple-table

            >
              <thead>
                <tr>
                  <td>주문 번호</td>
                  <td>결제 시간</td>
                  <td>상품명</td>
                  <td>금액</td>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="payment in paymentHistory"
                  v-bind:key="payment.transactionId"
                >
                  <td>{{ payment.transactionId }}</td>
                  <td>{{ (new Date(payment.paidTime)).format('yyyy-MM-dd (KS) HH:mm:ss') }}</td>
                  <td>{{ payment.name }}</td>
                  <td>{{ numberWithCommas(payment.amount) }}원</td>

                </tr>
              </tbody>
            </v-simple-table>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import { api } from '../mixins/api.js'
import { formUtility } from '../mixins/formUtility.js';

export default {
  async created() {
    await this.getPaymentHistory();
  },
  data() {
    return {
      paymentHistory: null
    }
  },
  methods: {
    async getPaymentHistory() {
      const paymentHistory = await api.methods.getPaymentHistoryApi();
      this.paymentHistory = paymentHistory;
    },
  },
  mixins: [formUtility],
}
</script>
